import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  ShowButton,
  FilterButton,
  ExportButton,
} from 'react-admin';

const HorseList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'name', order: 'ASC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="external_id" label="ID" />
        <TextField source="name" />
        <TextField source="sire_number" label="Sire number" />
        <TextField source="sex" />
        <TextField source="birthdate" />
        <TextField source="owner" label="Owner" />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default HorseList;
